import axios from "axios";

export type UploadImageOptions = {
  onProgress?: (percent: number) => void;
};

export const uploadImage = async (
  signedUrl: string,
  file: File,
  options?: UploadImageOptions,
) => {
  if (options?.onProgress) {
    await axios.put(signedUrl, file, {
      onUploadProgress: (event) => {
        if (event.total && event.total > 0) {
          const percent = Math.round((event.loaded * 100) / event.total);
          options.onProgress?.(Math.min(100, percent));
        }
      },
    });
    options.onProgress(100);
    return;
  }

  const res = await fetch(signedUrl, {
    method: "PUT",
    body: new Blob([file]),
  });
  if (!res.ok) {
    const detail = await res.text().catch(() => "");
    throw new Error(
      `Upload failed (${res.status}): ${detail || res.statusText}`.trim(),
    );
  }
  return res;
};
